import React from "react";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";

const NotFound: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        minWidth: "80vw",
        textAlign: "center",
        backgroundColor: "#171717",
      }}
    >
      <h1
        style={{
          fontSize: isMobile ? "2rem" : "4rem",
          marginBottom: "1rem",
          color: "#333",
        }}
      >
        404
      </h1>
      <h2
        style={{
          fontSize: isMobile ? "1.5rem" : "2rem",
          marginBottom: "2rem",
          color: "#aeaea0",
        }}
      >
        Page Not Found
      </h2>
      <p
        style={{
          fontSize: isMobile ? "1rem" : "1.2rem",
          marginBottom: "2rem",
          color: "#aeaea0",
          maxWidth: "600px",
        }}
      >
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        style={{
          padding: "12px 24px",
          backgroundColor: "#6EA8FE",
          color: "white",
          textDecoration: "none",
          borderRadius: "5px",
          fontSize: isMobile ? "1rem" : "1.1rem",
          transition: "background-color 0.3s ease",
        }}
      >
        Go to Home
      </Link>
    </div>
  );
};

export default NotFound;
